const style = (theme) => ({
    stepper: {
        marginBottom: '30px',
        '& .MuiPaper-root' : {
          marginTop: '0px!important'
        }
      }
});

export default style;